import { render, staticRenderFns } from "./policy-JP.vue?vue&type=template&id=3a8e50a4&"
import script from "./policy-JP.vue?vue&type=script&lang=js&"
export * from "./policy-JP.vue?vue&type=script&lang=js&"
import style0 from "./policy-JP.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports